import React from 'react';
import styled from 'react-emotion';

import theme from '@jetshop/ui/utils/theme';
import t from '@jetshop/intl';

import ProductTabs from './ProductTabs';
import MaxWidth from '../Layout/MaxWidth';
import { LipscoreProductReview } from '../Lipscore/LipscoreProductReview';
import { LipscoreQuestions } from '../Lipscore/LipscoreQuestions';

const Wrapper = styled(MaxWidth)`
  width: 100%;
`;

export const SectionHeading = styled('h2')`
  font-size: 20px;
  margin-bottom: 1rem;

  ${theme('below.md')} {
    margin: 0;
  }
`;

export const ProductSection = styled('section')`
  width: 100%;
  padding-bottom: 3rem;
  ${theme('below.md')} {
    padding: 15px 20px;
    margin: 0;
    border-bottom: 4px solid #f7f7f7;
  }
`;

const SpecField = styled('div')`
  font-size: 1rem;
  display: block;
  padding: 5px 10px;
  span {
    font-weight: bold;
    margin-right: 2px;
  }

  &:nth-of-type(odd) {
    background: #f3f3f3;
  }
`;

const ProductInfo = (props) => {
  return (
    <Wrapper>
      <ProductTabs
        id="product-tabs"
        activeIndex={props.activeIndex ? props.activeIndex : '1'}
        setActiveTab={props.setActiveTab}
      >
        <div index="1" label={t('More information')}>
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: props.product.shortDescription,
              }}
            />
          </div>
        </div>

        {props.specs &&
        props.specs.listValues &&
        props.specs.listValues.length > 0 ? (
          <div index="2" label={t('Specifications')}>
            <div>
              {props.specs.listValues.map((value, index) => {
                let title = value.split(' : ')[0];
                let text = value.split(' : ')[1];
                return (
                  <SpecField key={index}>
                    <span>{title}: </span>
                    {text}
                  </SpecField>
                );
              })}
            </div>
          </div>
        ) : null}

        <div index="3" label={t('Ratings & Reviews')}>
          <LipscoreProductReview product={props.product} />
        </div>
        <div index="4" label={t('Questions & Answers')}>
          <LipscoreQuestions product={props.product} />
        </div>
      </ProductTabs>
    </Wrapper>
  );
};

export default ProductInfo;
